const defaultConfig = {
  surveyId: "39db0bd2-ef3c-408d-9a7b-164bccacebe2",
  surveyPostId: "93b7496d-70c9-4a0b-bda0-15126915c544",
};

function getFirstQueryValue(params, keys) {
  for (const key of keys) {
    const value = params.get(key);
    if (value && value.trim()) return value.trim();
  }
  return "";
}

function buildSurveyConfigFromQuery() {
  if (typeof window === "undefined") return defaultConfig;

  try {
    const params = new URLSearchParams(window.location.search);
    const surveyId = getFirstQueryValue(params, [
      "survey_id",
      "survey-id",
      "surveyId",
      "=survey_id",
    ]);
    const surveyPostId = getFirstQueryValue(params, [
      "survey_post_id",
      "survey-post-id",
      "surveyPostId",
      "=survey_post_id",
    ]);

    return {
      surveyId: surveyId || defaultConfig.surveyId,
      surveyPostId: surveyPostId || defaultConfig.surveyPostId,
    };
  } catch (error) {
    console.log("Survey config query parse error:", error);
    return defaultConfig;
  }
}

export const surveyConfig = buildSurveyConfigFromQuery();
